import React, { Fragment, useState, FC } from "react";
import {
  Button,
  Dialog,
  Grid,
  IconButton,
  DialogTitle as MuiDialogTitle,
} from "@mui/material";

interface LocationMapProps {
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  button?: string;
  buttonClass?: string;
}

interface CustomDialogTitleProps {
  onClose?: () => void;
}

const DialogTitle: FC<CustomDialogTitleProps> = ({ onClose }) => (
  <MuiDialogTitle>
    {onClose && (
      <IconButton
        className="event-close-btn"
        aria-label="close"
        onClick={onClose}
        size="large"
      >
        <i className="ti-close"></i>
      </IconButton>
    )}
  </MuiDialogTitle>
);

const LocationMap: FC<LocationMapProps> = ({
  maxWidth = "md",
  button = "See Location",
  buttonClass = "",
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  return (
    <Fragment>
      {/* Open Dialog Button */}
      <Button
        className={`btn ${buttonClass}`}
        onClick={handleClickOpen}
        variant="contained"
      >
        {button}
      </Button>

      {/* Modal Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        className="modalWrapper quickview-dialog"
        maxWidth={maxWidth}
      >
        <DialogTitle onClose={handleClose} />
        <Grid className="modalBody modal-body">
          <iframe 
            title="Location Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3773.289758448612!2d-98.98852742412554!3d18.962806455514947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ce6d36b6ab60c9%3A0x29e6cbe04d61e61f!2sJard%C3%ADn%20Los%20Faroles!5e0!3m2!1ses!2smx!4v1773478333077!5m2!1ses!2smx" 
            width="600" 
            height="450" 
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy" 
          ></iframe>
        </Grid>
      </Dialog>
    </Fragment>
  );
};

export default LocationMap;
